var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "invoiceDetail" } },
    [
      _c("AppBreadCrumb", {
        attrs: {
          paths: [
            { title: _vm.$t("billing.invoiceManagement"), path: "/billing" },
            { title: "Fatura Detay" },
          ],
          select: true,
        },
      }),
      _vm._v(" "),
      _c("div", { staticClass: "invoice-detail-content" }, [
        _c("div", { staticClass: "invoice" }, [
          _c(
            "div",
            {
              staticClass: "invoice-head",
              staticStyle: { "margin-bottom": "20px" },
            },
            [
              _c("div", { staticClass: "row-item" }, [
                _c("div", { staticClass: "column-item" }, [
                  _c("div", { staticClass: "title" }, [_vm._v("Site")]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.siteName)),
                  ]),
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "column-item" }, [
                  _c("div", { staticClass: "title" }, [
                    _vm._v("Billing Period"),
                  ]),
                  _vm._v(" "),
                  _c("div", { staticClass: "content" }, [
                    _vm._v(_vm._s(_vm.formatDate())),
                  ]),
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "column-item", staticStyle: { width: "30%" } },
                  [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("Bill Status"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(_vm._s(_vm.invoice.paid ? "Ödendi" : "Ödenmedi")),
                    ]),
                  ]
                ),
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  class:
                    _vm.invoice.isManuel && _vm.invoice.description
                      ? "row-item-space-between"
                      : "row-item-end",
                },
                [
                  _vm.invoice.description
                    ? _c("div", { staticClass: "column-item" }, [
                        _c("div", { staticClass: "title" }, [
                          _vm._v("Açıklama"),
                        ]),
                        _vm._v(" "),
                        _c("div", { staticClass: "content" }, [
                          _vm._v(_vm._s(_vm.invoice.description)),
                        ]),
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _c("div", { staticClass: "column-item" }, [
                    _c("div", { staticClass: "title" }, [
                      _vm._v("Total Price + KDV"),
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "content" }, [
                      _vm._v(_vm._s(~~(_vm.invoice.price || 0)) + "₺"),
                    ]),
                  ]),
                ]
              ),
            ]
          ),
          _vm._v(" "),
          _vm.formatedDetails.length > 0
            ? _c(
                "div",
                {
                  staticClass: "invoice-head",
                  staticStyle: { "margin-bottom": "20px" },
                },
                [_vm._m(0)]
              )
            : _vm._e(),
          _vm._v(" "),
          _vm.formatedDetails.length > 0
            ? _c(
                "div",
                { staticClass: "details" },
                _vm._l(_vm.formatedDetails, function (plan) {
                  return _c("div", { staticClass: "detail-content" }, [
                    _c("div", { staticClass: "head" }, [
                      _c("div", { staticClass: "title" }, [
                        _vm._v(
                          "\n                            " +
                            _vm._s(
                              _vm.title[plan.type] ||
                                plan.type
                                  .split("-")
                                  .map(function (c) {
                                    return (
                                      c[0].toUpperCase() +
                                      c.slice(1).toLowerCase()
                                    )
                                  })
                                  .join(" ")
                            ) +
                            "\n                            "
                        ),
                        _vm.isFeature(plan)
                          ? _c("span", { staticClass: "ml-1" }, [
                              _vm._v(" (Özellik) "),
                            ])
                          : _vm._e(),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "price" }, [
                        _vm._v(_vm._s(~~(plan.totalPrice.price || 0)) + "₺"),
                      ]),
                    ]),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "content" },
                      _vm._l(Object.values(plan.details), function (detail) {
                        return _c(
                          "div",
                          { staticClass: "detail-content-child" },
                          [
                            _c("div", { staticClass: "head" }, [
                              _c("div", { staticClass: "title" }, [
                                _c("span", [
                                  _vm._v(
                                    _vm._s(detail.plan.title) +
                                      " " +
                                      _vm._s(detail.plan.altTitle) +
                                      "\n                                        " +
                                      _vm._s(
                                        detail.plan.type === "supsis"
                                          ? "(" +
                                              detail.planAction.details
                                                .agentCount +
                                              " Agent) " +
                                              (_vm.getFreeAgentCount(
                                                detail.plan.features
                                              )
                                                ? "(+" +
                                                  _vm.getFreeAgentCount(
                                                    detail.plan.features
                                                  ) +
                                                  " Ücretsiz)"
                                                : "")
                                          : [
                                              "whatsapp-business",
                                              "whatsapp",
                                            ].includes(detail.plan.type)
                                          ? "(" +
                                            detail.planAction.details
                                              .whatsappChannel +
                                            " Kanal)"
                                          : detail.plan.type === "instagram"
                                          ? "(" +
                                            detail.planAction.details
                                              .instagramChannel +
                                            " Kanal)"
                                          : detail.plan.type === "messenger"
                                          ? "(" +
                                            detail.planAction.details
                                              .messengerChannel +
                                            " Kanal)"
                                          : ""
                                      )
                                  ),
                                ]),
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      detail.plan.type === "extra-package"
                                        ? "(" +
                                            detail.sessionCount +
                                            " Session)"
                                        : detail.startDate +
                                            " - " +
                                            detail.endDate
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "price" }, [
                                _vm._v(
                                  "\n                                    " +
                                    _vm._s(
                                      plan.type == "chatbot"
                                        ? detail.sessionCount + " Session"
                                        : (detail.price || 0) > 0
                                        ? (detail.price || 0).toFixed(2) + "₺"
                                        : ""
                                    ) +
                                    "\n                                "
                                ),
                              ]),
                            ]),
                          ]
                        )
                      }),
                      0
                    ),
                  ])
                }),
                0
              )
            : _vm._e(),
        ]),
      ]),
    ],
    1
  )
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row-item" }, [
      _c("div", { staticClass: "column-item" }, [
        _c("div", { staticClass: "title" }, [_vm._v("Details")]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }